<template>
  <div class="summary" v-if="getProductLoaded">
    <table class="table">
      <tr v-if="withProducts">
        <th scope="col" class="col-md-5">Produkt</th>
        <th scope="col" class="col-md-2">Liczba</th>
        <th scope="col" class="col-md-2">Wartość</th>
        <th scope="col" class="col-md-3">Suma</th>
      </tr>
      <fragment v-if="withProducts">
        <tr v-for="item in paginatedItems" :key="item.id" >
          <td v-if="item.id !== 1000002" class="col-md-5 col-lg-5">{{ item.name }}</td>
          <td v-if="item.id !== 1000002" class="col-md-2 col-lg-2 text-nowrap">{{ item.quantity }}
            szt
          </td>
          <td v-if="item.id !== 1000002" class="col-md-2 col-lg-2 text-nowrap">{{
            item.price.toFixed(2)}} zł
          </td>
          <td v-if="item.id !== 1000002" class="col-md-3 col-lg-3 text-nowrap">{{ (item.price *
            item.quantity).toFixed(2) }} zł
          </td>
        </tr>
        <tr v-if="totalPageCount > 1">
          <td colspan="4">
            <pagination size="sm" v-model="currentPage" :total-page="totalPageCount"></pagination>
          </td>
        </tr>
      </fragment>
      <fragment v-if="withProducts">
        <tr v-for="item in getOnlyConfectionItems" :key="item.id">
          <td v-if="item.id !== 1000002 && item.quantity > 0" colspan="3">{{ item.name }}</td>
          <td v-if="item.id !== 1000002 && item.quantity > 0" class="text-nowrap">{{ (item.price *
            item.quantity).toFixed(2) }} zł
          </td>
        </tr>
      </fragment>
      <tr aria-hidden="true">
        <td colspan="4"></td>
      </tr>
      <tr class="summary__grossValueRow">
        <td class="col-md-5 col-lg-5" colspan="3"><strong>RAZEM BRUTTO</strong></td>
        <td class="col-md-3 col-lg-3 text-nowrap"><strong>{{ summary }} zł</strong></td>
      </tr>
      <tr aria-hidden="true">
        <td colspan="4"></td>
      </tr>
      <tr class="font-weight-bold">
        <td class="col-md-5 col-lg-5" colspan="3">Razem netto</td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{ netSummary }} zł
        </td>
      </tr>
      <tr v-if="withProducts">
        <td class="col-md-5 col-lg-5" colspan="3">VAT</td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{ calculateCommision.commissionItems.vat.toFixed(2) }} zł
        </td>
      </tr>
      <tr v-if="withProducts">
        <td class="col-md-5 col-lg-5" colspan="3">Łączna wartość doładowania produktów netto</td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{ netProductsValue }} zł
        </td>
      </tr>
      <tr v-if="getProductVatFromStore === 0 && withProducts">
          <!-- this.$store.state.customer.loaded-->
        <td class="col-md-5 col-lg-5" colspan="3">Prowizja <Icon v-tooltip="getDescription" icon="info" />
        </td>
        <td class="col-md-3 col-lg-3 text-nowrap">
         {{calculateCommision.commissionItems.commission.toFixed(2)}} zł
        </td>
      </tr>
      <tr v-if="withProducts && !this.isProductEVoucher">
        <td class="col-md-5 col-lg-5" colspan="3">
          Usługa bezpiecznej dostawy
          <Icon v-if="!isVirtualCard" id="deliveryIcon" icon="info" v-tooltip="deliveryTooltip" />
        </td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{calculateCommision.commissionItems.delivery_fee.toFixed(2)}} zł
        </td>
      </tr>
      <tr v-if="withProducts && isProductPhysicalCard">
        <td class="col-md-5 col-lg-5" colspan="3">Opłata za wydanie karty</td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{calculateCommision.commissionItems.card_fee.toFixed(2)}} zł
        </td>
      </tr>
      <tr v-if="withProducts && ['ECV_ISS', 'ND_ECV_ISS'].includes(this.getProductType)">
        <td class="col-md-5 col-lg-5" colspan="3">Opłata za obsługę i utrzymanie karty</td>
        <td class="col-md-3 col-lg-3 text-nowrap">
          {{calculateCommision.commissionItems.card_fee.toFixed(2)}} zł
        </td>
      </tr>
      <tr v-if="withProducts && isOnlinePayment">
        <td class="col-md-5 col-lg-5" colspan="3">Płatność on-line</td>
        <td class="col-md-3 col-lg-3 text-nowrap">9.23 zł</td>
      </tr>
    </table>
    <CustomAlert v-if="showBenefits" type="success">
      <template #icon>
        <span class="alert__icon mi mi-discount"></span>
      </template>
      <p class="m-0" v-html="getBenefitsDescription"></p>
    </CustomAlert>
    <CustomAlert type="warning" v-if="summaryVisibility === summaryVisibilityOptions.HIDE">
      <h4 class="summary--hide__title">Cena nie uwzględnia Twoich indywidualnych warunków zamawiania.</h4>
      <p class="mb-0">
        O akceptację finalnej ceny zamówienia poprosimy Cię tuż przed złożeniem zamówienia.
        W przypadku wątpliwości skontaktuj się z <a href="https://pluxee.pl/kontakt/sklep/" target="_blank" rel="external nofollow">Centrum Obsługi Klienta.</a>
      </p>
    </CustomAlert>
    <slot name="continue"></slot>
  </div>
</template>

<script>

import Vue from 'vue';
import { mapState } from 'vuex';
import Icon from '../Icon.vue';
import CustomAlert from '../CustomAlert.vue';
import { CommisionStrategyManager } from '@/utils/CommisionStrategyManager';
import { CouponStrategy } from '@/utils/CouponStrategy';
import { checkProductsIsVirtualCard, DELIVERY_POINTS_CATEGORY } from '@/utils/categoryUtils';
import { summaryVisibilityOptions } from '@/utils/constants/summary';
import { firstOrNull } from '@/utils/arrays';

const PAGE_SIZE = 20;

const pitBenefitsProducts = [
  30194, 30174, 30195, 30192, 30143, 29833, 30126, 30675, 30702, 30937,
];
const zusBenefitsProducts = [
  29832, 30009,
];
const vatBenefitsProducts = [
  30193, 30144, 29830,
];
const vatCouponBenefitsProducts = [
  28249, 28250, 28251, 28252,
];
const allBenefitsProducts = [
  ...pitBenefitsProducts,
  ...zusBenefitsProducts,
  ...vatBenefitsProducts,
  ...vatCouponBenefitsProducts,
];

export default Vue.extend({
  name: 'Summary',
  props: ['affix', 'withProducts'],
  components: {
    Icon,
    CustomAlert,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapState({
      summaryVisibility: state => state.customer.contract.summary_option,
    }),
    totalPageCount() {
      const totalItems = this.getItemsWithoutConfection.length;
      return Math.ceil(totalItems / PAGE_SIZE);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * PAGE_SIZE;
      const end = start + PAGE_SIZE;
      return this.getItemsWithoutConfection.slice(start, end);
    },
    getBasketItems() {
      return this.$store.getters['delivery/getItemsTotal'];
    },
    getItemsWithoutConfection() {
      return this.$store.getters['delivery/getItemsWithoutConfection'];
    },
    getOnlyConfectionItems() {
      return this.$store.getters['delivery/getOnlyConfectionItems'];
    },
    isProductEVoucher() {
      return this.$store.getters.isProductEVoucher;
    },
    isProductPhysicalCard() {
      return this.$store.getters.isProductPhysicalCard;
    },
    isProductNde() {
      return this.$store.getters.isProductNde;
    },
    isOnlinePayment() {
      return this.$store.getters['cart/getOnlinePayment'] === 'true';
    },
    getProductType() {
      return this.$store.getters.getProductType;
    },
    getProductLoaded() {
      return this.$store.getters.getProductLoaded;
    },
    getProductVatFromStore() {
      const product = this.$store.state.products.all.products[0];
      return Number(product.vat);
    },
    getDescription() {
      const individualContracts = this.$store.state.customer.contract.individual;
      const defaultContracts = this.$store.state.customer.contract.default;

      let contract = null;
      if (this.isProductNde) {
        contract = firstOrNull(individualContracts) || firstOrNull(defaultContracts) || null;
      } else {
        contract = firstOrNull(defaultContracts) || firstOrNull(individualContracts) || null;
      }
      if (!contract) return '';

      const percentage = contract.commissionPercentageFee;
      const minimum = contract.commissionFixedFee;

      if (percentage && minimum) {
        return `(${percentage}% min. ${minimum} zł)`;
      }

      return '';
    },
    getDeliveryDescription() {
      return 'Twoje zamówienie jest dla nas priorytetem, dlatego korzystamy z bezpiecznej dostawy';
    },
    productId() {
      const product = this.$store.state.products.all.products[0];
      return product.idproducts;
    },
    showBenefits() {
      return allBenefitsProducts.includes(this.productId);
    },
    getBenefitsDescription() {
      if (pitBenefitsProducts.includes(this.productId)) {
        return 'Przy finansowaniu z ZFSŚ skorzystasz ze <b>zwolnienia z PIT do 1000 zł</b> rocznie na pracownika';
      }
      if (zusBenefitsProducts.includes(this.productId)) {
        return 'Pamiętaj, że doładowując miesięcznie kartę za 450 zł korzystasz ze zwolnienia z ZUS - <b>rocznie to aż do 1106 zł oszczędności</b> na jednym wynagrodzeniu.';
      }
      if (vatBenefitsProducts.includes(this.productId)) {
        return 'Pamiętaj, że <b>nagrody finansowe są zwolnione z podatku VAT</b> - nie płacisz go od kwoty doładowania karty.';
      }
      if (vatCouponBenefitsProducts.includes(this.productId)) {
        return 'Pamiętaj, że <b>nagrody finansowe są zwolnione z podatku VAT</b> - nie płacisz go od wartości nominalnej kuponów.';
      }
      return '';
    },
    calculateCommision() {
      const total = this.$store.getters['delivery/getTotal'];

      if (total.summary > 0 || total.quantity > 0) {
        const strategyManager = new CommisionStrategyManager();

        if (this.isProductEVoucher) {
          strategyManager.strategy = new CouponStrategy();
          // strategyManager.strategy = new EVoucherStrategy();
        } else {
          strategyManager.strategy = new CouponStrategy();
        }
        const res = strategyManager.calculateCommission(total, this.$store.state, this.$store.getters);
        if (res) {
          this.$store.dispatch('cart/setTax', res.commissionItems.vat.toFixed(2));
          this.$store.dispatch('cart/setShippingCost', res.commissionItems.delivery_fee.toFixed(2));
          this.$store.dispatch('customer/setChosenContract', res.commissionItems.contract_id);
        }

        return res;
      }
      total.quantity = 0;
      total.commissionItems = {
        commission: 0,
        has_commission: false,
        delivery_fee: 0,
        card_fee: 0,
        vat: 0,
        contract_id: 'default',
      };
      return total;
    },
    summary() {
      let { summary } = this.calculateCommision;
      summary = Number(summary.toFixed(2));
      const {
        commission, delivery_fee, card_fee, vat,
      } = this.calculateCommision.commissionItems;

      /**
       * Condition for eVoucher products
       */
      let cardFeeForProducts = this.isProductEVoucher ? 0 : card_fee;
      const deliveryFeeForProducts = this.isProductEVoucher ? 0 : delivery_fee;
      cardFeeForProducts = Number(cardFeeForProducts.toFixed(2));

      let wholeSummary = summary + commission + deliveryFeeForProducts + cardFeeForProducts + vat;
      if (this.isOnlinePayment) {
        wholeSummary += 9.23;
      }
      const formattedSummary = wholeSummary.toFixed(2);
      this.$store.dispatch('cart/setGrossSummary', formattedSummary);
      return formattedSummary;
    },
    netSummary() {
      const { vat } = this.calculateCommision.commissionItems;
      const netSummary = this.summary - vat;
      return netSummary.toFixed(2);
    },
    netProductsValue() {
      const products = this.getItemsWithoutConfection.filter(item => item.product_category !== DELIVERY_POINTS_CATEGORY);
      const netProductsValue = products.reduce((total, item) => total + (item.price * item.quantity), 0);
      return netProductsValue.toFixed(2);
    },
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
    deliveryTooltip() {
      return `
      <div class="d-flex align-items-center delivery-tooltip__inner">
        <span class="delivery-tooltip__text">Dbamy o to, żeby Twoje zamówienie dotarło bezpiecznie i sprawnie do rąk własnych osoby upoważnionej do odbioru.</span>
        <a href="https://www.pluxee.pl/faq/czym-jest-usluga-bezpiecznej-dostawy-pluxee/" target="_blank" class="btn delivery-tooltip__btn">Więcej</a>  
      </div>
      `;
    },
  },
  created() {
    this.summaryVisibilityOptions = summaryVisibilityOptions;
  },
});
</script>

<style>
.tooltip .tooltip-inner {
  text-align: left;
}
</style>
